<template>
	<div>
		<h5 class="font-weight-bolder mb-1">
			{{ `Torneos Jugados por ${specimen.alias ? specimen.alias : "---"} (${specimen.plate})` }}
		</h5>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-th class="text-center">Torneo</b-th>
					<b-th class="text-center">Etapa</b-th>
					<b-th class="text-center">Rival</b-th>
					<b-th class="text-center">Fecha</b-th>
					<b-th class="text-center">Resultado</b-th>
					<b-th style="z-index: 9999">Video</b-th>
				</b-thead>
				<b-tbody>
					<template v-if="confrontations.length > 0">
						<b-tr v-for="(confrontation, index) in confrontations" :key="index">
							<b-td class="text-center">
								<div>
									<ViewImage
										:specimen="{
											id: index,
											url: confrontation.torneo.url_image,
										}"
									/>
								</div>
								<small>{{ confrontation.torneo.name }}</small>
							</b-td>
							<b-td class="text-center">
								<b-badge :style="{ background: confrontation.torneo.stage_color }">
									{{ confrontation.torneo.stage }}
								</b-badge>
							</b-td>
							<b-td class="text-center">
								{{ confrontation.rival_name }}
							</b-td>
							<b-td class="text-center">
								<span>{{ confrontation.date | myGlobalDayShort }}</span>
							</b-td>
							<b-td class="text-center">
								<b-badge :variant="variantResult[confrontation.result]" class="text-uppercase">
									{{ confrontation.result }}
								</b-badge>
							</b-td>
							<b-td>
								<div class="d-flex align-items-center gap-x-2">
									<div
										v-if="confrontation.video.status == 2"
										@click="ValidStatusVideo(confrontation)"
										class="cursor-pointer"
									>
										<b-avatar
											:src="confrontation.video.thumb"
											rounded
											size="80"
											icon="film"
											badge
											badge-variant="danger"
										>
											<template #badge>
												{{ confrontation.video.duration || "-" }}
											</template>
										</b-avatar>
									</div>
									<div v-else>
										<b-badge variant="danger">Sin video</b-badge>
									</div>
								</div>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="confrontations.length === 0">
						<b-td colspan="10" class="text-center" style="height: 80px">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</div>
</template>

<script>
import videosService from "@/services/videos.service"
import { mapActions } from "vuex"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import specimensService from "@/services/specimens.service"
import ViewImage from "@/components/commons/ViewImage.vue"
import KnifeIcon from "@/components/commons/Icons/KnifeIcon.vue"
export default {
	components: { SpecimenPlate, ViewImage, KnifeIcon },
	props: {
		specimen: Object,
		result: String,
	},
	data() {
		return {
			confrontations: [],
			variantResult: {
				triunfo: "success",
				empate: "warning",
				derrota: "danger",
			},
			isLoading: false,
		}
	},
	computed: {},
	methods: {
		...mapActions("header_book", ["toggleModal", "setIndexImage", "setTextImage", "setImages"]),
		async ValidStatusVideo(row) {
			if (row.video.aws_hls_url) {
				this.showTopeVideo(row)
				return
			}
			const { data: valid } = await videosService.validStatusVideo({
				id: row.video.uid,
			})
			if (valid.valid) {
				this.showTopeVideo(row)
			} else {
				this.showToast("warning", "top-right", "Resultados", "WarningIcon", "El video no esta listo todavia")
			}
		},
		showTopeVideo(row) {
			this.setImages([
				{
					...row.video,
					type: "video",
					url: row.video.uid,
					aws_hls_url: row.video.aws_hls_url,
					text: `${row.specimen.alias ? row.specimen.alias : ""} (${row.specimen.plate}) VS ${
						row.rival_name
					}`,
					specimen: { id: row.specimen.id },
				},
			])
			this.setIndexImage(0)
			this.toggleModal()
		},
		async getDetails() {
			this.isLoading = true
			try {
				const { data } = await specimensService.getTournamentDetailsBySpecimen(this.specimen.id)
				this.confrontations = data.filter((item) => item.result === this.result)
			} catch (error) {
				console.log(error)
			} finally {
				this.isLoading = false
			}
		},
	},
	async mounted() {
		await this.getDetails()
	},
}
</script>

<style>
.label-filter {
	font-size: 0.8rem;
}

.nav.nav-tabs {
	flex-wrap: nowrap;
	overflow-x: auto;
	padding-bottom: 0.5rem;
}

.nav-link {
	white-space: nowrap;
}
</style>
